import React from "react"
import { Box, Button, Flex, Text } from "@chakra-ui/react"
import { CloseIcon } from "@chakra-ui/icons"
import chunk from "lodash.chunk"
import { Header } from "./Headline"
import { colors } from "../colors/colors"
import { Image } from "../image/Image"

export function StatesClubs({
  title,
  subheader,
  stateCount,
  clubCount,
  clubs,
}) {
  const [activeIndex, setActiveIndex] = React.useState(null)
  const [activeState, setActiveState] = React.useState(null)

  return (
    <Box>
      <Box m="0 auto" maxW="1024px" p="30px 0">
        <Header
          textAlign="center"
          fontSize={{ base: `36px`, lg: "60px" }}
          lineHeight={{ base: `60px`, lg: "80px" }}
          color="black"
        >
          {title}
        </Header>

        {subheader && (
          <Text
            textAlign="center"
            color="black"
            fontSize="18px"
            fontWeight={400}
            mb="10px"
            p={{ base: `0 20px`, lg: 0 }}
          >
            {subheader}
          </Text>
        )}

        <Box maxW="240px" m="30px auto 0">
          <Flex justifyContent="space-between" alignItems="center">
            <Box>
              <Header
                fontSize={{ base: `50px` }}
                lineHeight={{ base: `40px` }}
                color={colors.blue}
              >
                {stateCount}+
              </Header>
              <Header
                mt="10px"
                fontSize="30px"
                lineHeight="30px"
                letterSpacing="-1px"
                color={colors.gray}
              >
                States
              </Header>
            </Box>
            <Box>
              <Header
                fontSize={{ base: `50px` }}
                lineHeight={{ base: `40px` }}
                color={colors.blue}
              >
                {clubCount}+
              </Header>
              <Header
                mt="10px"
                fontSize="30px"
                lineHeight="30px"
                letterSpacing="-1px"
                color={colors.gray}
              >
                Clubs
              </Header>
            </Box>
          </Flex>
        </Box>
      </Box>
      <Box maxW={{ base: 375, sm: 500, md: 776, lg: 1028 }} m="0 auto">
        <Flex flexWrap="wrap">
          {chunk(clubs, 4, {}).map((clubChunk, clubChunkIndex) => {
            return (
              <Flex
                key={clubChunkIndex}
                flex={{ base: "0 0 100%" }}
                flexWrap="wrap"
              >
                {clubChunk.map(
                  ({ title, logo, cta, description }, clubIndex) => {
                    const isOpen =
                      `${title?.split(" ").join("-")}` === activeIndex
                    return (
                      <Box
                        flex={{ base: `0 0 50%`, lg: "0 0 25%" }}
                        key={title}
                      >
                        <Box position="relative">
                          <Box
                            key={`${title?.split(" ").join("-")}`}
                            border="1px solid #C7C7CC"
                            flex={{
                              base: `0 0 50%`,
                              lg: "0 0 220px",
                              xl: "0 0 257px",
                            }}
                            alignSelf="center"
                            mt="-1px"
                            mr={"-1px"}
                          >
                            <Button
                              bg="white"
                              _hover={{
                                bg: `#F2F2F7`,
                              }}
                              onClick={() => {
                                if (isOpen) {
                                  setActiveIndex(null)
                                  setActiveState(null)
                                  return
                                }
                                setActiveState(null)
                                setActiveIndex(null)

                                setActiveIndex(`${title?.split(" ").join("-")}`)
                                setActiveState({ title, description, cta })
                              }}
                              display="block"
                              w="100%"
                              height="200px"
                              p="45px 0"
                            >
                              <Flex>
                                <Box
                                  maxWidth="100px"
                                  m="0 auto"
                                  alignSelf="center"
                                  flex="1 0 0px"
                                >
                                  <Image image={logo?.localFile} />
                                </Box>
                              </Flex>
                            </Button>
                          </Box>
                          <Box
                            position={{ base: `absolute`, sm: `initial` }}
                            zIndex={2}
                            transition="all 0.2s ease-in-out"
                            color="black"
                            maxHeight={isOpen ? "1000px" : 0}
                            minHeight={isOpen ? "200px" : 0}
                            overflow={isOpen ? "visible" : `hidden`}
                            opacity={isOpen ? 1 : 0}
                            marginLeft={{
                              lg: `${-257 * clubIndex}px`,
                              md: clubIndex % 2 === 0 ? 0 : `-387px`,
                              sm: clubIndex % 2 === 0 ? 0 : `-250px`,
                              base: clubIndex % 2 === 0 ? 0 : `-185px`,
                            }}
                            width={{
                              lg: isOpen ? `calc(300% + ${258}px)` : 0,
                              sm: isOpen ? `200%` : 0,
                              base: isOpen ? `200%` : 0,
                            }}
                            maxWidth={{ base: `375px`, sm: `initial` }}
                          >
                            <Box
                              key={`${activeState?.title
                                ?.split(" ")
                                .join("-")}`}
                              p="20px"
                              border="1px solid #C7C7CC"
                              flex={{ base: `0 0 100%`, lg: "0 0 100%" }}
                              alignSelf="center"
                              bg="white"
                              zIndex={4}
                              textAlign="left"
                              minHeight="240px"
                            >
                              <Flex justifyContent="flex-end">
                                <Box textAlign="right" flex="0 0 auto">
                                  <Button
                                    bg="white"
                                    _hover={{
                                      bg: `transparent`,
                                    }}
                                    onClick={() => {
                                      setActiveIndex(null)
                                      setActiveState(null)
                                    }}
                                    display="block"
                                    height="auto"
                                  >
                                    <CloseIcon name="close" color="black" />
                                  </Button>
                                </Box>
                              </Flex>
                              {activeState?.title && (
                                <Header
                                  mt="10px"
                                  mb={{ base: `10px`, lg: "15px" }}
                                  fontSize={{ base: `36px`, lg: "40px" }}
                                  lineHeight={{
                                    base: `30px`,
                                    sm: `36px`,
                                    lg: "40px",
                                  }}
                                  letterSpacing="-1.33px"
                                  color="black"
                                >
                                  {activeState?.title}
                                </Header>
                              )}
                              {activeState?.description && (
                                <Text
                                  color="black"
                                  fontSize="18px"
                                  lineHeight="30px"
                                  m="0"
                                >
                                  {`"${activeState?.description}"`}
                                </Text>
                              )}

                              {activeState?.cta && (
                                <Text
                                  color="black"
                                  fontSize="18px"
                                  lineHeight="30px"
                                  fontWeight="bold"
                                  m="16px 0 0"
                                >
                                  {activeState?.cta}
                                </Text>
                              )}
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    )
                  }
                )}
              </Flex>
            )
          })}
        </Flex>
      </Box>
    </Box>
  )
}
